const SET_SAVED_VIEW = "appoptics/infrastructure/SET_SAVED_VIEW";
const CLEAR_SAVED_VIEW = "appoptics/infrastructure/CLEAR_SAVED_VIEW";
const CLEAR_NEW_FORM = "appoptics/infrastructure/CLEAR_NEW_FORM";
const UPDATE_NEW_FORM = "appoptics/infrastructure/UPDATE_NEW_FORM";
const UPDATE_EDIT_FORM = "appoptics/infrastructure/UPDATE_EDIT_FORM";
const UPDATE_SAVE_AS_FORM = "appoptics/infrastructure/UPDATE_SAVE_AS_FORM";

const INITIAL_STATE = {
  isViewSet: false,
  view: {
    id: null,
    name: null,
    public: null,
    viewUrl: null,
    description: null,
  },
  newForm: {
    name: "",
    public: true,
    description: "",
  },
  clickToSaveForm: {
    id: null,
    name: null,
    public: null,
    description: null,
  },
  saveAsForm: {
    name: null,
    public: null,
    description: null,
  },
  editForm: {
    id: null,
    name: null,
    public: null,
    description: null,
  },
};

export const setSavedView = view => ({
  type: SET_SAVED_VIEW,
  view,
});

export const updateEditForm = form => ({
  type: UPDATE_EDIT_FORM,
  form,
});

export const updateNewForm = form => ({
  type: UPDATE_NEW_FORM,
  form,
});

export const updateSaveAsForm = form => ({
  type: UPDATE_SAVE_AS_FORM,
  form,
});

export const clearNewForm = () => ({ type: CLEAR_NEW_FORM });

export const clearSavedView = () => ({
  type: CLEAR_SAVED_VIEW,
});

const buildSaveAsForm = view => ({
  name: view.preconfigured ? `${view.name} (copy)` : view.name,
  public: view.public,
  description: view.description,
});

const buildForm = view => ({
  id: view.id,
  name: view.name,
  public: view.public,
  description: view.description,
});

const savedViewReducer = (state = INITIAL_STATE, { type, view, form }) => {
  switch (type) {
    case SET_SAVED_VIEW:
      return {
        ...state,
        view,
        isViewSet: true,
        editForm: buildForm(view),
        clickToSaveForm: buildForm(view),
        saveAsForm: buildSaveAsForm(view),
      };
    case UPDATE_EDIT_FORM:
      return {
        ...state,
        editForm: buildForm(form),
      };
    case UPDATE_NEW_FORM:
      return {
        ...state,
        newForm: {
          name: form.name,
          public: form.public,
          description: form.description,
        },
      };
    case UPDATE_SAVE_AS_FORM:
      return {
        ...state,
        saveAsForm: buildSaveAsForm(form),
      };
    case CLEAR_NEW_FORM:
      return {
        ...state,
        newForm: INITIAL_STATE.newForm,
      };
    case CLEAR_SAVED_VIEW:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default savedViewReducer;
